import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { appInfo } from './app-info';
import { appRoutes } from './app-routes';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';
import { useAuth } from './contexts/auth';
import { usePortalNotifications } from './hooks/usePortalNotifications';

export const Content = () => {
  const { user } = useAuth();
  usePortalNotifications(user?.token, user?.tenantName);
  return (
    <SideNavBarLayout title={appInfo.title}>
      <Routes>
        {appRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
              <Route path='*' element={<Navigate to='/worktasks-planning' />} />
      </Routes>
    </SideNavBarLayout>
  );
};
